<template>
  <ul class="lv-timeline">
    <li class="lv-timeline-item" v-for="(item, index) in 4" :key="index">
      <div class="lv-timeline-item__tail"></div>

      <div class="lv-timeline-item__node"></div>

      <div class="lv-timeline-item__wrapper">
        <div class="lv-timeline-item__timestamp is-left">15秒前</div>

        <div class="lv-timeline-item__content">
          <!-- 可用slot -->
          <div class="slote flex_start">
            <div class="lay">
              <img src="~assets/base/small_rentou.png" />
            </div>
            <div>
              <div class="layname">XX律师</div>
              <div class="answer ellipsis">
                {{ `完成了用户151******45的...` | toEllipsisFilter(spl) }}
              </div>
            </div>
          </div>
          <!-- 可用slot -->
        </div>
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    spl: Number,
  },
};
</script>

<style lang="scss" scoped>
.lv-timeline-item {
  width: 100%;
  position: relative;
  margin-top: 30px;
  text-align: left;
  &:last-child {
    .lv-timeline-item__tail {
  height: 70px;
    }
  }
}

.lv-timeline-item:hover {
  .lv-timeline-item__timestamp {
    color: #333;
  }

  .lv-timeline-item__node {
    background-color: #0465ea;
  }
}

.lv-timeline-item__timestamp.is-left {
  position: absolute;
  top: 10px;
  left: 4px;
}

.lv-timeline-item__tail {
  position: absolute;
  top: 10px;
  left: 65px;
  height: 140%;
  border-right: 1px solid #ccc;
}

.lv-timeline-item__node {
  position: absolute;
  top: 10px;
  left: 54px;
  z-index: 1;
  transform: translateX(50%);
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #ccc;
}

.lv-timeline-item__wrapper {
  padding-left: 90px;
}

.lv-timeline-item__content {
  color: #666666;
  padding: 0 23px 31px 0;
}

.lv-timeline-item__timestamp {
  color: #909399;
  line-height: 1;
  font-size: 14px;
}

.slote {
  .lay {
    margin-right: 10px;
    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }
  .layname {
    font-size: 20px;
    line-height: 20px;
    color: #333;
  }

  .answer {
    font-size: 14px;
    line-height: 14px;
    margin-top: 10px;
    color: #666;
  }
}
</style>


